import React from "react";

import { alphabeticalSorter } from "~/tools/alphabetical-sorter";

import type { UnmatchedCheckState } from "../../common/openapi";
import { Table } from "../react/table/Table";
import type { ColumnsType } from "../react/table/TableTypes";

const UNMAPPED_TABLE_COLUMNS: ColumnsType<UnmatchedCheckState> = [
	{
		title: "Monitor health state ID",
		dataIndex: "checkStateId",
		filterMode: "search",
		sorter: (a, b) => alphabeticalSorter(a.checkStateId, b.checkStateId),
	},
	{
		title: "Component identifier",
		dataIndex: "topologyElementIdentifier",
		filterMode: "search",
		sorter: (a, b) => alphabeticalSorter(a.topologyElementIdentifier, b.topologyElementIdentifier),
	},
];

export const UnmappedComponentsTabContent: React.FC<{ unmatchedCheckStates: Array<UnmatchedCheckState> }> = ({
	unmatchedCheckStates,
}) => (
	<Table
		columns={UNMAPPED_TABLE_COLUMNS}
		data={unmatchedCheckStates}
		dimHeaderAndBorders
		pagination={false}
		rowKey="checkStateId"
		sticky
		withHover
	/>
);
